export class SearchPatientReq {
  userId: number;
  firstName: string;
  lastName: string;
  // dob: string;
  phoneNumber: string;
  pageIndex: number;
  itemsCount: number;
  criteria: string;
  parenttype: string = "";
  healthOrganizationId: number;
  employerId: number;
}

export interface SearchPatientRes {
  id: number;
  userId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  birthDate: string;
  gender: string;
  lastAppointmentDate: string;
  nextAppointmentDate: string;
  photoUrl: string;
  appyId: string;
  patientActiveSubscription: PatientActiveSubscription;  // Add this property

}
export interface PatientActiveSubscription {
  id: number;
  patientId: number;
  employerId: number;
  subscriptionTypeId: number;
  active: boolean;
  startDate: string;
  endDate: string | null;
  activationType: string | null;
  errorMessage: string | null;
  subscriptionType: string | null;
  subscriptionPlans: any[];
}